import './Skeleton.css'

export default function Skeleton({ w = '100%', h = '100px', r = '0', ...props }) {
  return <div className={'skeleton ' + props.otraClassname} style={{width: w, minHeight: h, borderRadius: r}}/>
}
